import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import useTailwindBreakpoint from "../../hooks/useTailwindBreakpoint";
import NavbarDesktop from "./NavbarDesktop";
import NavbarMobile from "./NavbarMobile";
export default function Navbar() {
    const isLg = useTailwindBreakpoint("lg");
    return _jsx(_Fragment, { children: isLg ? _jsx(NavbarDesktop, {}) : _jsx(NavbarMobile, {}) });
}
